import { LogoIcon } from './LogoIcon';
import { useAppContext } from '../../shared';

export const Logo = () => {
  const { meta } = useAppContext();

  return (
    <div className="pb-lg grow w-full text-center flex items-center gap-x-lg">
      <LogoIcon />
      <span className="font-bold text-section">
        {meta.tenant.name || ' - '}
      </span>
    </div>
  );
};
